import { ChatCompletionStream } from "./ChatCompletionStream.mjs";
export class ChatCompletionStreamingRunner extends ChatCompletionStream {
    static fromReadableStream(stream) {
        const runner = new ChatCompletionStreamingRunner();
        runner._run(() => runner._fromReadableStream(stream));
        return runner;
    }
    static runFunctions(completions, params, options) {
        const runner = new ChatCompletionStreamingRunner();
        runner._run(() => runner._runFunctions(completions, params, {
            ...options,
            headers: { ...options?.headers, 'X-Stainless-Helper-Method': 'runFunctions' },
        }));
        return runner;
    }
    static runTools(completions, params, options) {
        const runner = new ChatCompletionStreamingRunner();
        runner._run(() => runner._runTools(completions, params, {
            ...options,
            headers: { ...options?.headers, 'X-Stainless-Helper-Method': 'runTools' },
        }));
        return runner;
    }
}
//# sourceMappingURL=ChatCompletionStreamingRunner.mjs.map